import type { ReactNode } from 'react';

/**
 * The building blocks of a Help page, for the core's guides and a client's own (`app.help`):
 * short sections, numbered steps, a tip, and the words of a button or menu as the screen
 * shows them.
 */

export function GuideSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="mt-6 first:mt-0">
      <h2 className="text-base font-semibold text-slate-900">{title}</h2>
      <div className="mt-2 space-y-3 text-sm leading-6 text-slate-700">{children}</div>
    </section>
  );
}

/** Numbered steps. Each child is an `<li>`. */
export function GuideSteps({ children }: { children: ReactNode }) {
  return <ol className="list-decimal space-y-1.5 pl-5 marker:text-slate-400">{children}</ol>;
}

export function GuideTip({ children }: { children: ReactNode }) {
  return (
    <p className="rounded-md border border-brand-muted bg-brand-soft px-3 py-2 text-brand-strong">
      {children}
    </p>
  );
}

/** A button, menu entry or heading as it reads on the screen. */
export function OnScreen({ children }: { children: ReactNode }) {
  return <strong className="font-semibold text-slate-900">{children}</strong>;
}
